
export type ChangeSubscriptionPlanBody = {
  /** 변경할 플랜 ID */
  newPlanId: string;
  /** 실제 플랜 코드 (백엔드에서 플랜 검색에 사용) */
  productPlanCode?: string;
  /** 변경 사유 */
  reason?: string;
};
